export default "__VITE_ASSET__0ch7x_T2__"